import { IFormProfileDataContainer } from "./IFormProfileInfo";
/**
* Základní informace o profilu formuláře a jeho definice
*/
export class FormProfileBasicItem {
    public id: number;
    public name: string;
    public locKey: string;
    public data: IFormProfileDataContainer;
    public jsonData: string;
    /** Režim formuláře, ve kterém nejsou při jeho otevření načteny žádná data */
    public queryMode: boolean | null;
    public selected: boolean;
    public defaultProfile: boolean;
    public showInNavigationTree: boolean;
    public storeFilters: boolean;
    public isImplementation: boolean;
    public get basic(): boolean {
        return this.id == null;
    }

    constructor(id: number | string, name: string, jsonData: string, data: IFormProfileDataContainer, defaultProfile: boolean, showInNavigationTree: boolean, isImplementation: boolean, locKey: string = "") {
        this.id = (typeof id === "string") ? Number(id) : id;
        this.name = name;
        this.locKey = locKey;
        this.jsonData = jsonData;
        this.data = data;
        this.selected = false;
        this.defaultProfile = defaultProfile;
        this.showInNavigationTree = showInNavigationTree;
        this.queryMode = data.formProfileData?.queryMode;
        this.storeFilters = data.formProfileData?.storeFilters ?? true;
        this.isImplementation = isImplementation;
    }
}
